import { DocumentModel, FileModel, TaskModel } from '@turiya/orchestrator-renderer-react';
import { TableRow } from 'react-data-table-component';

export const GET_ENVIRONMENT_CONFIGURATIONS_MESSAGE = 'GetEnvironmentConfigurations';
export const SYSTEM_HEALTH_METRICS_MESSAGE = 'CkycDashboardSystemHealthMetricsStreaming';
export const INTERNAL_AGING_DATA_MESSAGE = 'CkycDashboardInternalAgingDataStreaming';
export const EXTERNAL_AGING_DATA_MESSAGE = 'CkycDashboardExternalAgingDataStreaming';
export const SYSTEM_HEALTH_RECORDS_STATUS_MESSAGE = 'CkycDashboardSystemHealthRecordsStatusStreaming';
export const SYSTEM_HEALTH_BATCH_STATUS_MESSAGE = 'CkycDashboardSystemHealthBatchStatusStreaming';
export const AGING_MANUAL_REVIEW_DATA_MESSAGE = 'CkycDashboardAgingManualReviewDataStreaming';
export const SYSTEM_HEALTH_BUSINESS_STATUS_MESSAGE = 'CkycDashboardSystemHealthBusinessStatusStreaming';
export const FUNNEL_METRICS_MESSAGE = 'CkycDashboardFunnelMetricsStreaming';
export const FUNNEL_DATA_MESSAGE = 'CkycDashboardFunnelDataStreaming';
export const FUNNEL_DATA_DOWNLOAD_MESSAGE = 'CkycDashboardFunnelDataDownload2';
export const GENERATE_REPORTS_DOWNLOAD_MESSAGE = 'CkycDashboardGenerateReportDownloadData2';
export const GET_CITY_STATE_FROM_PIN_CODE = 'GetCityStateFromPinCodeStreaming';
export const GET_STATES_FROM_PIN_CODE = 'GetStatesFromPinCodeStreaming';
export const GET_DISTRICTS_FOR_STATES = 'GetDistrictsFromStateStreaming';
export const GET_MASKED_IMAGE_FROM_DOCUMENTS = 'GetMaskedImageFromDocuments';
export const GET_FACE_PICTURE_FROM_DOCUMENT = 'GetFacePictureFromDocument';
export const GET_BULK_CREATE_TASK_INSIGHTS_DATA = 'GetBulkCreateTaskDataInsightsStreaming';
export const GET_BULK_UPLOAD_TEMPLATE = 'GetBulkUploadTemplate';
export const GET_METRICS_OVERVIEW_DATA = 'GetMetricsOverviewData';
export const GET_VALID_DOCUMENT_MODEL = 'GetValidDocumentModel';
export const SFTP_PASSWORD_CHANGE_MESSAGE = 'UpdateSFTPCredentials';
export const GET_REPORT_TYPE_DATA = 'GetReportTypeData';
export const GET_PRODUCT_TYPE_DATA = 'GetLOSType';
export const SEARCH_PHOENIX_USERS = 'SearchPhoenixUsers';
export const ADD_PHOENIX_USER = 'AddPhoenixUser';
export const UPDATE_PHOENIX_USER = 'UpdatePhoenixUser';
export const TRIGGER_BULK_EXCEL_UPLOAD = 'StartBulkTriggerXlsxWF';
export const GLOBAL_SEARCH_CASE = 'globalSearchCase';

export enum Gender {
    MALE = 'M',
    FEEMALE = 'F',
}
export enum Salutation {
    MR = 'MR.',
    MRS = 'MRS.',
    MR1 = 'MR',
    MRS1 = 'MRS',
    MS = 'MS.',
}

export enum CheckerActions {
    ACCEPT = 'accept',
    REJECT = 'reject',
}

export const DROPDOWN_TO_LABEL: Record<Gender | Salutation, string> = {
    [Gender.MALE]: 'Male',
    [Gender.FEEMALE]: 'Female',
    [Salutation.MR]: 'Mr.',
    [Salutation.MRS]: 'Mrs.',
    [Salutation.MR1]: 'Mr.',
    [Salutation.MRS1]: 'Mrs.',
    [Salutation.MS]: 'Ms.',
};

export interface SystemHealthMetrics {
    averageCkycP0ResponseInMinutes: number;
    averageNoOfRecordsPerBatch: number;
    averageTotalTatInMinutes: number;
    recordsProcessedPerMinutes: number;
    totalRecordsProcessed: number;
}

export interface Metrics {
    snapshot: {
        stp: {
            currentPeriodPercentage: number;
            currentPeriodCount: number;
            priorPeriodPercentage: number;
            priorPeriodCount: number;
        };
        manual: {
            currentPeriodPercentage: number;
            currentPeriodCount: number;
            priorPeriodPercentage: number;
            priorPeriodCount: number;
        };
        failures: {
            currentPeriodPercentage: number;
            currentPeriodCount: number;
            priorPeriodPercentage: number;
            priorPeriodCount: number;
            subStagesCurrentPeriod: {
                dataQualityCount: number;
                retryInProgressCount: number;
                systemFailuresCount: number;
            };
        };
    };
    realtime: {
        manual: {
            currentPeriodPercentage: number;
            currentPeriodCount: number;
            priorPeriodPercentage: number;
            priorPeriodCount: number;
            makerCheckerCurrentPeriod: {
                makerPercentage: number;
                makerCount: number;
                checkerPercentage: number;
                checkerCount: number;
            };
            subStagesCurrentPeriod: {
                insertCount: number;
                updateCount: number;
                downloadAuthCount: number;
                probableMatchCount: number;
            };
        };
        queued: {
            currentPeriodPercentage: number;
            currentPeriodCount: number;
            priorPeriodPercentage: number;
            priorPeriodCount: number;
            subStagesCurrentPeriod: {
                awaitingSubmissionCount: number;
                sentToCKYCCount: number;
            };
        };
        awaitingResponse: {
            currentPeriodPercentage: number;
            currentPeriodCount: number;
            priorPeriodPercentage: number;
            priorPeriodCount: number;
        };
        ckycCompleted: {
            currentPeriodPercentage: number;
            currentPeriodCount: number;
            priorPeriodPercentage: number;
            priorPeriodCount: number;
            subStagesCurrentPeriod: {
                insertCount: number;
                updateCount: number;
                reverseFeedCount: number;
            };
        };
        ckycRejected: {
            currentPeriodPercentage: number;
            currentPeriodCount: number;
            priorPeriodPercentage: number;
            priorPeriodCount: number;
            subStagesCurrentPeriod: {
                insertCount: number;
                updateCount: number;
            };
        };
    };
}

export enum UploadDocumentsActionTypes {
    UPLOAD_AADHAAR = 'UPLOAD_AADHAAR',
    UPLOAD_PASSPORT = 'UPLOAD_PASSPORT',
    UPLOAD_VOTER_ID = 'UPLOAD_VOTER_ID',
    UPLOAD_DRIVING_LICENSE = 'UPLOAD_DRIVING_LICENSE',
    UPLOAD_NATIONAL_POPULATION_REGISTER_LETTER = 'UPLOAD_NATIONAL_POPULATION_REGISTER_LETTER',
}

export enum ManualReviewStatus {
    INSERT = 'INSERT',
    UPDATE = 'UPDATE',
}

export enum ManualReviewStatuses {
    MANUAL_REVIEW = 'MANUAL_REVIEW',
    PARTIAL_DATA = 'PARTIAL_DATA',
    PARTIAL_DOCUMENT = 'PARTIAL_DOCUMENT',
    PROBABLE_MATCH = 'PROBABLE_MATCH',
}

export enum ManualReviewDrilledDownStatuses {
    STP_FAILURE = 'STP_FAILURE',
    CKYC_REJECTED = 'CKYC_REJECTED',
    PROBABLE_MATCH = 'PROBABLE_MATCH',
    DOWNLOAD_FAILED = 'DOWNLOAD_FAILED',
}

//old
export interface ManualReviewRecordStatusChartDatav2 {
    age: string;
    partialDataCount?: number;
    manualReviewCount?: number;
    partialDocumentCount?: number;
    probableMatchCount?: number;
}

export interface ManualReviewSubCounts {
    stpFailureCount: number;
    ckycRejectedCount: number;
    probableMatchCount: number;
}

export interface ManualRecordsDrilledDownData {
    insertCount: number;
    insertSubComponents: ManualReviewSubCounts;
    updateCount: number;
    downloadAuthFailedCount: number;
    updateSubComponents: ManualReviewSubCounts;
}

export interface ManualReviewRecordStatusChartData {
    name: string;
    value: number;
    fill: string;
}

export const MANUAL_REVIEW_STATUS_TO_LABEL: Record<string, string> = {
    [ManualReviewStatus.INSERT]: 'Insert',
    [ManualReviewStatus.UPDATE]: 'Update',
};

export const MANUAL_REVIEW_DRILLED_STATUS_TO_LABEL: Record<string, string> = {
    [ManualReviewDrilledDownStatuses.CKYC_REJECTED]: 'CKYC Rejected',
    [ManualReviewDrilledDownStatuses.DOWNLOAD_FAILED]: 'Download Failed',
    [ManualReviewDrilledDownStatuses.PROBABLE_MATCH]: 'Probable Match',
    [ManualReviewDrilledDownStatuses.STP_FAILURE]: 'STP Failure',
};

export const MANUAL_REVIEW_STATUS_TO_LABEL_V1: Record<string, string> = {
    [ManualReviewStatuses.MANUAL_REVIEW]: 'Manual Review',
    [ManualReviewStatuses.PARTIAL_DATA]: 'Partial Data',
    [ManualReviewStatuses.PARTIAL_DOCUMENT]: 'Partial Document',
    [ManualReviewStatuses.PROBABLE_MATCH]: 'Probable Match',
};

export enum RecordStatuses {
    CREATED = 'CREATED',
    PROCESSING = 'PROCESSING',
    QUEUED_FOR_SUBMISSION = 'QUEUED_FOR_SUBMISSION',
    AWAITING_RESPONSE = 'AWAITING_RESPONSE',
    MANUAL = 'MANUAL',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
}

export interface AgedRecordStatusChartData {
    age: number;
    period: string;
    createdCount: number;
    processingCount: number;
    queuedForSubmissionCount: number;
    awaitingResponseCount: number;
    manualCount: number;
    failedCount: number;
    completedCount: number;
}

export interface RecordStatusChartData {
    period: string;
    business?: string;
    createdCount: number;
    processingCount: number;
    queuedForSubmissionCount: number;
    awaitingResponseCount: number;
    manualCount: number;
    failedCount: number;
    completedCount: number;
}

const RECORD_STATUS_TO_LABEL: Record<RecordStatuses, string> = {
    [RecordStatuses.CREATED]: 'Created',
    [RecordStatuses.PROCESSING]: 'Processing',
    [RecordStatuses.QUEUED_FOR_SUBMISSION]: 'Queued for Submission',
    [RecordStatuses.AWAITING_RESPONSE]: 'Awaiting Response',
    [RecordStatuses.MANUAL]: 'Manual',
    [RecordStatuses.COMPLETED]: 'Completed',
    [RecordStatuses.FAILED]: 'Failed',
};

export const COUNT_TO_RECORD_STATUS_LABEL: Record<string, string> = {
    createdCount: RECORD_STATUS_TO_LABEL[RecordStatuses.CREATED],
    processingCount: RECORD_STATUS_TO_LABEL[RecordStatuses.PROCESSING],
    queuedForSubmissionCount: RECORD_STATUS_TO_LABEL[RecordStatuses.QUEUED_FOR_SUBMISSION],
    awaitingResponseCount: RECORD_STATUS_TO_LABEL[RecordStatuses.AWAITING_RESPONSE],
    manualCount: RECORD_STATUS_TO_LABEL[RecordStatuses.MANUAL],
    failedCount: RECORD_STATUS_TO_LABEL[RecordStatuses.FAILED],
    completedCount: RECORD_STATUS_TO_LABEL[RecordStatuses.COMPLETED],
};

export enum BatchStatuses {
    SENT = 'SENT',
    PENDING_RESOLUTION = 'PENDING_RESOLUTION',
    COMPLETED = 'COMPLETED',
}

export interface BatchStatusChartData {
    period: string;
    sentCount?: number;
    pendingResolutionCount?: number;
    completedCount?: number;
}

const BATCHD_STATUS_TO_LABEL: Record<BatchStatuses, string> = {
    [BatchStatuses.SENT]: 'Sent',
    [BatchStatuses.PENDING_RESOLUTION]: 'Pending Resolution',
    [BatchStatuses.COMPLETED]: 'Completed',
};

export const COUNT_TO_BATCH_STATUS_LABEL: Record<string, string> = {
    sentCount: BATCHD_STATUS_TO_LABEL[BatchStatuses.SENT],
    pendingResolutionCount: BATCHD_STATUS_TO_LABEL[BatchStatuses.PENDING_RESOLUTION],
    completedCount: BATCHD_STATUS_TO_LABEL[BatchStatuses.COMPLETED],
};

export enum ProcessingStatuses {
    API_PUSH = 'API_PUSH',
    CREATE_BATCH = 'CREATE_BATCH',
    PENDING_APPROVAL = 'PENDING_APPROVAL',
    PROCESSING = 'PROCESSING',
    INPUT_VALIDATION = 'INPUT_VALIDATION',
    INPUT_VALIDATION_FAILED = 'INPUT_VALIDATION_FAILED',
    UPLOADED = 'UPLOADED',
    UPLOAD_FAILED = 'UPLOAD_FAILED',
    DEDUPE = 'DEDUPE',
    DEDUPE_FAILED = 'DEDUPE_FAILED',
    DECISIONING = 'DECISIONING',
    SEARCH_AND_DOWNLOAD = 'SEARCH_AND_DOWNLOAD',
    SEARCH_AND_DOWNLOAD_FAILED = 'SEARCH_AND_DOWNLOAD_FAILED',
    DECISIONING_FAILED = 'DECISIONING_FAILED',
    DATA_VALIDATION = 'DATA_VALIDATION',
    DATA_VALIDATION_PARTIAL_DATA = 'DATA_VALIDATION_PARTIAL_DATA',
    DATA_VALIDATION_FAILED = 'DATA_VALIDATION_FAILED',
    IMAGE_PROCESSING = 'IMAGE_PROCESSING',
    REPORTING_WIP = 'REPORTING_WIP',
    QUEUED = 'QUEUED',
    MAKER_REVIEW = 'MAKER_REVIEW',
    CHECKER_REVIEW = 'CHECKER_REVIEW',
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED',
    NOTIFY_CKYC = 'NOTIFY_CKYC',
    DOWNLOAD_AUTH_FAILED = 'DOWNLOAD_AUTH_FAILED',
    CKYC_PROCESSING = 'CKYC_PROCESSING',
    PROBABLE_MATCH = 'PROBABLE_MATCH',
    REVERSE_FEED = 'REVERSE_FEED',
    REJECTED = 'REJECTED',
    CONFIRMED_MATCH = 'CONFIRMED_MATCH',
}

export const PROCESSING_STATUS_TO_LABEL: Record<ProcessingStatuses, string> = {
    [ProcessingStatuses.API_PUSH]: 'API Push',
    [ProcessingStatuses.CREATE_BATCH]: 'Create Batch',
    [ProcessingStatuses.PENDING_APPROVAL]: 'Pending Approval',
    [ProcessingStatuses.PROCESSING]: 'Processing',
    [ProcessingStatuses.INPUT_VALIDATION]: 'Input Validation',
    [ProcessingStatuses.INPUT_VALIDATION_FAILED]: 'Failed',
    [ProcessingStatuses.UPLOADED]: 'Uploaded',
    [ProcessingStatuses.UPLOAD_FAILED]: 'Failed',
    [ProcessingStatuses.DEDUPE]: 'Dedupe',
    [ProcessingStatuses.DEDUPE_FAILED]: 'Failed',
    [ProcessingStatuses.DECISIONING]: 'Decisioning',
    [ProcessingStatuses.SEARCH_AND_DOWNLOAD]: 'Search & Download',
    [ProcessingStatuses.SEARCH_AND_DOWNLOAD_FAILED]: 'Failed',
    [ProcessingStatuses.DECISIONING_FAILED]: 'Failed',
    [ProcessingStatuses.DATA_VALIDATION]: 'Data Validation',
    [ProcessingStatuses.IMAGE_PROCESSING]: 'Image Processing',
    [ProcessingStatuses.DATA_VALIDATION_PARTIAL_DATA]: 'Partial Data',
    [ProcessingStatuses.DATA_VALIDATION_FAILED]: 'Failed',
    [ProcessingStatuses.REPORTING_WIP]: 'Reporting WIP',
    [ProcessingStatuses.QUEUED]: 'Queued',
    [ProcessingStatuses.MAKER_REVIEW]: 'Maker Review',
    [ProcessingStatuses.CHECKER_REVIEW]: 'Checker Review',
    [ProcessingStatuses.SUCCESS]: 'Success',
    [ProcessingStatuses.FAILED]: 'Failed',
    [ProcessingStatuses.NOTIFY_CKYC]: 'Notify CKYC',
    [ProcessingStatuses.DOWNLOAD_AUTH_FAILED]: 'Download Auth Fail',
    [ProcessingStatuses.CKYC_PROCESSING]: 'CKYC Processing',
    [ProcessingStatuses.PROBABLE_MATCH]: 'Probable Match',
    [ProcessingStatuses.REVERSE_FEED]: 'Reverse Feed',
    [ProcessingStatuses.REJECTED]: 'Rejected',
    [ProcessingStatuses.CONFIRMED_MATCH]: 'Confirmed Match',
};

export interface FunnelMetrics {
    initialValidationCount: number;
    dataValidationCount: number;
    dataValidationFailedCount: number;
    dataValidationPartialDataCount: number;
    decisioningCount: number;
    decisioningFailedCount: number;
    dedupeCount: number;
    dedupeFailedCount: number;
    failedCount: number;
    reportingWipCount: number;
    successCount: number;
    uploadedCount: number;
    uploadedFailedCount: number;
    approvalPendingCount: number;
    processingBatchCount: number;
    inputValidationCount: number;
    inputValidationFailedCount: number;
    searchAndDownloadCount: number;
    searchAndDownloadFailureCount: number;
    downloadAuthFailedCount: number;
    ckycNotifiedCount: number;
    imageProcessingCount: number;
    makerReviewCount: CountOfRecords;
    checkerReviewCount: CountOfRecords;
    queuedForSubmissionCount: CountOfRecords;
    ckycProcessingCount: number;
    probableMatchCount: number;
    ckycRejectedCount: number;
    ckycConfirmedMatchCount: number;
    reverseFeedCompletedCount: number;
}

export interface CountOfRecords {
    insertCount: number;
    updateCount: number;
}

export interface PaginatedResults<T> {
    currentPage: number;
    items: T[];
    totalItems: number;
    totalPages: number;
}

export type PaginatedOperationsData = PaginatedResults<OperationsData>;

export type PaginatedBatchDataTable = PaginatedResults<BatchDataTable>;

export enum ExistingBatchesTables {
    PENDING_TABLE = 'PENDING_APPROVAL',
    APPROVED_TABLE = 'APPROVED',
    REJECTED_TABLE = 'REJECTED',
}

export const EXISTING_BATCHES_TABLE_TO_LABEL: Record<ExistingBatchesTables, string> = {
    [ExistingBatchesTables.PENDING_TABLE]: 'Pending',
    [ExistingBatchesTables.APPROVED_TABLE]: 'Approved',
    [ExistingBatchesTables.REJECTED_TABLE]: 'Rejected',
};

export interface OperationsData extends TableRow {
    clientRef: string;
    ckycNumber?: string | null;
    kycOperation: string | null;
    operationDate: string;
    status: ProcessingStatuses;
    failureReason?: string | null;
}

export interface BatchDataTable extends TableRow {
    batchName: string;
    eventIdentifier: string;
    remarks: string | null;
    isIndividual: boolean;
    successfulCount: string;
    inProgressCount: string;
    failedCount: string;
    totalCount: string;
    createdAt: string;
    createdBy: string;
    rejectedAt: string | null;
    rejectedBy: string | null;
    updatedAt: string | null;
    updatedBy: string | null;
    rejectedReason: string | null;
}
export interface PendingTableData extends TableRow {
    batchName: string;
    type: TaskUserTypeV2;
    file?: Array<Record<string, object>>;
    recordCount: string;
    createdOn: string;
    createdBy: string;
}

export interface ApprovedTableData extends TableRow {
    batchName: string;
    type: TaskUserTypeV2;
    // recordCount: PostApprovalCount;
    recordCount: string;
    createdOn: string;
    createdBy: string;
    approvedOn: string | null;
    approvedBy: string | null;
}
export interface PostApprovalCount {
    successful: number;
    inProgress: number;
    failed: number;
}
export interface PostApprovalCount {
    successful: number;
    inProgress: number;
    failed: number;
}

export interface RejectedTableData extends TableRow {
    batchName: string;
    type: TaskUserTypeV2;
    recordCount: string;
    createdBy: string;
    rejectedOn: string | null;
    rejectedBy: string | null;
    rejectionReason: string | null;
}

export interface CheckerApprovalQueue extends TableRow {
    batchName: string;
    type: TaskUserTypeV2;
    recordCount: string;
    createdOn: string;
    createdBy: string;
}
export enum TimeUnit {
    HOURLY = 'HOURLY',
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    MONTHLY = 'MONTHLY',
    YEARLY = 'YEARLY',
}

export const DEFAULT_INTERNAL_MAX_AGE = 14;
export const DEFAULT_EXTERNAL_MAX_AGE = 7;
export const DEFAULT_INTERNAL_TAT_BREACH_THRESHOLD = 10;
export const DEFAULT_EXTERNAL_TAT_BREACH_THRESHOLD = 7;

export const TIME_UNIT_TO_PERIOD_METRICS: Record<TimeUnit, number> = {
    [TimeUnit.HOURLY]: 1,
    [TimeUnit.DAILY]: 1,
    [TimeUnit.WEEKLY]: 1,
    [TimeUnit.MONTHLY]: 1,
    [TimeUnit.YEARLY]: 1,
};

export const TIME_UNIT_TO_PERIOD: Record<TimeUnit, number> = {
    [TimeUnit.HOURLY]: 24,
    [TimeUnit.DAILY]: 7,
    [TimeUnit.WEEKLY]: 4,
    [TimeUnit.MONTHLY]: 12,
    [TimeUnit.YEARLY]: 4,
};

export const TIME_UNIT_TO_API_UNIT_PERIOD: Record<TimeUnit, string> = {
    [TimeUnit.HOURLY]: 'HOUR',
    [TimeUnit.DAILY]: 'DAY',
    [TimeUnit.WEEKLY]: 'WEEK',
    [TimeUnit.MONTHLY]: 'MONTH',
    [TimeUnit.YEARLY]: 'YEAR',
};

export const TIME_UNIT_TO_LABEL: Record<TimeUnit, string> = {
    [TimeUnit.HOURLY]: 'hour',
    [TimeUnit.DAILY]: 'day',
    [TimeUnit.WEEKLY]: 'week',
    [TimeUnit.MONTHLY]: 'month',
    [TimeUnit.YEARLY]: 'year',
};

// Reports

export enum ReportFormat {
    EXCEL = 'EXCEL',
}

export enum DownloadStatus {
    QUEUED = 'QUEUED',
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED',
}

export enum ProductType {
    ALL = 'ALL',
    CREDIT_CARD = 'CREDIT_CARD',
    ASSET_DIGITAL = 'ASSET_DIGITAL',
    ASSETS_ASSISTED = 'ASSETS_ASSISTED',
}

export const enum ReportType {
    TRIGGER_REPORT = 'TRIGGER_REPORT',
    DAILY_SUMMARY_REPORT = 'DAILY_SUMMARY_REPORT',
    REPORTING_STATUS_REPORT = ' REPORTING_STATUS_REPORT',
    BATCH_STATUS_REPORT = 'BATCH_STATUS_REPORT',
    BATCH_STATUS_REPORT_WEEKLY = 'BATCH_STATUS_REPORT_WEEKLY',
    BATCH_STATUS_REPORT_MONTHLY = 'BATCH_STATUS_REPORT_MONTHLY',
    PROBABLE_MATCH_REPORT = 'PROBABLE_MATCH_REPORT',
    CONFIRMED_MATCH_REPORT = 'CONFIRMED_MATCH_REPORT',
    INSERT_REPORT = 'INSERT_REPORT',
    UPDATE_REPORT = 'UPDATE_REPORT',
    DEDUPE_FAILED_REPORT = 'DEDUPE_FAILED_REPORT',
    PARTIAL_INFO_REPORT = 'PARTIAL_INFO_REPORT',
    DATA_VALIDATION_FAILURE_REPORT = 'DATA_VALIDATION_FAILURE_REPORT',
    SUBMISSION_FAILURE_REPORT = 'SUBMISSION_FAILURE_REPORT',
    PENDING_WIP_REPORT = 'PENDING_WIP_REPORT',
    UPLOAD_TAT_REPORT = 'UPLOAD_TAT_REPORT',
    SUBMISSION_TAT_REPORT = 'SUBMISSION_TAT_REPORT',
}

export enum TaskTypeV2 {
    INSERT = 'INSERT',
    UPDATE = 'UPDATE',
    NEW = 'NEW',
    PROBABLE_MATCH = 'PROBABLE_MATCH',
    RETRY = 'RETRY',
    DOWNLOAD_AUTH_FAILED = 'DOWNLOAD_AUTH_FAILED',
}

export enum TaskUserTypeV2 {
    INDIVIDUAL = 'INDIVIDUAL',
    ENTITY = 'ENTITY',
}
export enum MetricsUserType {
    INDIVIDUAL = 'INDIVIDUAL',
    ENTITY = 'ENTITY',
    ALL = 'ALL',
}
export enum OperationType {
    INSERT = 'insert',
    UPDATE = 'update',
}

export const METRICS_USER_TYPE_TO_NAME: Record<MetricsUserType, string> = {
    [MetricsUserType.INDIVIDUAL]: 'Individual',
    [MetricsUserType.ENTITY]: 'Entity',
    [MetricsUserType.ALL]: 'All',
};

export const TASK_TYPE_TO_NAME_V2: Record<TaskTypeV2, string> = {
    [TaskTypeV2.INSERT]: 'INSERT',
    [TaskTypeV2.UPDATE]: 'UPDATE',
    [TaskTypeV2.NEW]: 'NEW',
    [TaskTypeV2.PROBABLE_MATCH]: 'PROBABLE MATCH',
    [TaskTypeV2.RETRY]: 'RETRY',
    [TaskTypeV2.DOWNLOAD_AUTH_FAILED]: 'DOWNLOAD FAILED',
};

export const OPERATION_TYPE_TO_NAME: Record<OperationType, string> = {
    [OperationType.INSERT]: 'INSERT',
    [OperationType.UPDATE]: 'UPDATE',
};

export enum EntityType {
    INDIVIDUAL = 'individual',
    HUF = 'huf',
    SOLE_PROPRIETORSHIP = 'sole_proprietorship',
}

export type ImageInfo = Omit<FileModel, 'id'> & { storage?: string; type?: string };
export type documents = Array<ImageInfo | undefined | DocumentModel | string>;

export enum ProofTypes {
    IDENTITY_PROOF = 'IDENTITY_PROOF',
    PERMANENT_ADDRESS = 'PERMANENT_ADDRESS',
    CURRENT_ADDRESS = 'CURRENT_ADDRESS',
    IDENTITY_PROOF_ADDRESS_PROOF = 'IDENTITY_PROOF_ADDRESS_PROOF',
}
export const PROOF_TYPE_TO_NAME: Record<ProofTypes, string> = {
    [ProofTypes.IDENTITY_PROOF]: 'Identity Proof',
    [ProofTypes.PERMANENT_ADDRESS]: 'Permanent Address Proof',
    [ProofTypes.CURRENT_ADDRESS]: 'Current Address Proof',
    [ProofTypes.IDENTITY_PROOF_ADDRESS_PROOF]: 'Identity Proof, Address Proof',
};

export interface Document {
    name: IndividualDocumentTypes | EntityDocumentTypes;
    id: string;
    type: ProofTypes;
    image: ImageInfo;
}

export interface KycDocuments {
    docType: IndividualDocumentTypes | EntityDocumentTypes | 'PROFILE_PICTURE';
    docId: string;
    type?: ProofTypes;
    documents: documents;
}

export interface CkycDocuments {
    documentType: IndividualDocumentTypes | EntityDocumentTypes;
    documentId: string;
    documentImageUrls: Array<string>;
}

export interface ManualTaskHeaderData {
    id: string;
    cif: string;
    losAppId?: string;
    name: string;
    panNumber: string;
    date: string;
    task: TaskModel;
    operation: string;
    ckycOperationId: string;
    kycCompletedDate: string;
    taskType: TaskTypeV2;
    taskUserType: TaskUserTypeV2;
    isChecker: boolean;
    businessKey?: string;
    ckycRejected?: boolean;
    creationDate?: string;
    operationType?: OperationType;
    updateDate?: string;
    ckycNumber?: string;
    stageKey?: string;
}

export interface PinCodeDescriptor {
    pinCode: string;
    district: string;
    stateName: string;
    stateCode: string;
}

export interface DocumentMaskResponse {
    businessKey: string;
    processInstanceId: string;
    variables: Record<string, Array<OCRResponse>>;
}

export interface OCRResponse {
    documentType: string;
    docuementSubType: string;
    fields: Record<string, OCRFields>;
    scannedSide: string;
    turiyaDocumentUploadResponse: ImageInfo;
}

export interface OCRFields {
    value: string;
    confidence: number;
}
export interface DocumentMaskingPayload {
    image: ImageInfo;
    businessKey: string;
    ckycOperationId: string;
}

export interface PhotoExtractionPayload {
    businessKey: string;
    file: ImageInfo;
}

export interface PhotoExtractionResponse {
    turiyaDocumentUploadResponse: ImageInfo;
}

export interface GenerateReportTypes {
    key: string;
    value: string;
}
// Manual Tasks v2

export enum ManualTaskRecordFilter {
    NONE = 'NONE',
    AGING = 'AGING',
    CREATION_DATE = 'CREATION_DATE',
    DUE_DATE = 'DUE_DATE',
}

export const FILTER_NAME_TO_LABEL: Record<ManualTaskRecordFilter, string> = {
    [ManualTaskRecordFilter.NONE]: 'None',
    [ManualTaskRecordFilter.AGING]: 'Aging',
    [ManualTaskRecordFilter.CREATION_DATE]: 'Creation Date',
    [ManualTaskRecordFilter.DUE_DATE]: 'Due Date',
};

export enum ActionsTabMenu {
    ACTIONS = 'ACTIONS',
    PERSONAL_DETAILS = 'PERSONAL_DETAILS',
    ENTITY_DETAILS = 'ENTITY_DETAILS',
    ADDRESS = 'ADDRESS',
    RELATED_PERSON = 'RELATED_PERSON',
    CASE_HISTORY = 'CASE_HISTORY',
}

export const ACTION_NAME_TO_LABEL: Record<ActionsTabMenu, string> = {
    [ActionsTabMenu.ACTIONS]: 'ACTIONS',
    [ActionsTabMenu.PERSONAL_DETAILS]: 'PERSONAL DETAILS',
    [ActionsTabMenu.ENTITY_DETAILS]: 'ENTITY DETAILS',
    [ActionsTabMenu.ADDRESS]: 'ADDRESS',
    [ActionsTabMenu.RELATED_PERSON]: 'RELATED PERSON',
    [ActionsTabMenu.CASE_HISTORY]: 'CASE HISTORY',
};

export enum IndividualDocumentTypes {
    AADHAAR = 'AADHAAR',
    PASSPORT = 'PASSPORT',
    DRIVING_LICENSE = 'DRIVING_LICENSE',
    VOTER_ID = 'VOTER_ID',
    NATIONAL_POPULATION_REGISTER_LETTER = 'NATIONAL_POPULATION_REGISTER_LETTER',
    NREGA_JOB_CARD = 'NREGA_JOB_CARD',
    LETTER_OF_ALLOTMENT_OF_ACCOMMODATION = 'LETTER_OF_ALLOTMENT_OF_ACCOMMODATION',
    PENSION_PAYMENT_ORDERS = 'PENSION_PAYMENT_ORDERS',
    TAX_RECEIPT = 'TAX_RECEIPT',
    UTILITY_BILL = 'UTILITY_BILL',
}

export enum EntityDocumentTypes {
    CERTIFICATE_OF_INCORPORATION = 'CERTIFICATE_OF_INCORPORATION',
    REGISTRATION_CERTIFICATE = 'REGISTRATION_CERTIFICATE',
    OTHERS = 'OTHERS',
    ACTIVITY_PROOF_1 = 'ACTIVITY_PROOF_1',
    ACTIVITY_PROOF_2 = 'ACTIVITY_PROOF_2',
    MEMORANDUM_AND_ARTICLES_OF_ASSOCIATION = 'MEMORANDUM_AND_ARTICLES_OF_ASSOCIATION',
    OFFICIALLY_VALID_DOCUMENT_OF_AUTHORIZED_PERSON_TO_TRANSACT = 'OFFICIALLY_VALID_DOCUMENT_OF_AUTHORIZED_PERSON_TO_TRANSACT',
    PARTNERSHIP_DEED = 'PARTNERSHIP_DEED',
    POWER_OF_ATTORNEY_TO_TRANSACT = 'POWER_OF_ATTORNEY_TO_TRANSACT',
    RESOLUTION_OF_BOARD_OR_MANAGING_COMMITEE = 'RESOLUTION_OF_BOARD_OR_MANAGING_COMMITEE',
    TRUST_DEED = 'TRUST_DEED',
}

export const INDIVIDUAL_DOCUMENT_TYPES: Array<IndividualDocumentTypes> = [
    IndividualDocumentTypes.AADHAAR,
    IndividualDocumentTypes.PASSPORT,
    IndividualDocumentTypes.DRIVING_LICENSE,
    IndividualDocumentTypes.VOTER_ID,
    IndividualDocumentTypes.NATIONAL_POPULATION_REGISTER_LETTER,
    IndividualDocumentTypes.NREGA_JOB_CARD,
];

export const DEEMED_DOCUMENTS: Array<IndividualDocumentTypes> = [
    IndividualDocumentTypes.LETTER_OF_ALLOTMENT_OF_ACCOMMODATION,
    IndividualDocumentTypes.PENSION_PAYMENT_ORDERS,
    IndividualDocumentTypes.TAX_RECEIPT,
    IndividualDocumentTypes.UTILITY_BILL,
];

export const ENTITY_DOCUMENT_TYPES: Array<EntityDocumentTypes> = [
    EntityDocumentTypes.ACTIVITY_PROOF_1,
    EntityDocumentTypes.ACTIVITY_PROOF_2,
    EntityDocumentTypes.MEMORANDUM_AND_ARTICLES_OF_ASSOCIATION,
    EntityDocumentTypes.OFFICIALLY_VALID_DOCUMENT_OF_AUTHORIZED_PERSON_TO_TRANSACT,
    EntityDocumentTypes.PARTNERSHIP_DEED,
    EntityDocumentTypes.POWER_OF_ATTORNEY_TO_TRANSACT,
    EntityDocumentTypes.RESOLUTION_OF_BOARD_OR_MANAGING_COMMITEE,
    EntityDocumentTypes.TRUST_DEED,
    EntityDocumentTypes.CERTIFICATE_OF_INCORPORATION,
    EntityDocumentTypes.REGISTRATION_CERTIFICATE,
    EntityDocumentTypes.OTHERS,
];

export const DOCUMENT_TYPE_TO_NAME: Record<EntityDocumentTypes | IndividualDocumentTypes, string> = {
    [IndividualDocumentTypes.AADHAAR]: 'Aadhaar',
    [IndividualDocumentTypes.PASSPORT]: 'Passport',
    [IndividualDocumentTypes.DRIVING_LICENSE]: 'Driving License',
    [IndividualDocumentTypes.VOTER_ID]: 'Voter ID',
    [IndividualDocumentTypes.NATIONAL_POPULATION_REGISTER_LETTER]: 'National Population Register Letter',
    [IndividualDocumentTypes.NREGA_JOB_CARD]: 'NREGA Job Card',
    [EntityDocumentTypes.ACTIVITY_PROOF_1]: 'Activity Proof 1',
    [EntityDocumentTypes.ACTIVITY_PROOF_2]: 'Activity Proof 2',
    [EntityDocumentTypes.MEMORANDUM_AND_ARTICLES_OF_ASSOCIATION]: 'Memorandum and Articles of Association',
    [EntityDocumentTypes.OFFICIALLY_VALID_DOCUMENT_OF_AUTHORIZED_PERSON_TO_TRANSACT]:
        'Officially Valid Document of Authorized Person to Transact',
    [EntityDocumentTypes.PARTNERSHIP_DEED]: 'Partnership Deed',
    [EntityDocumentTypes.POWER_OF_ATTORNEY_TO_TRANSACT]: 'Power of Attorney to Transact',
    [EntityDocumentTypes.RESOLUTION_OF_BOARD_OR_MANAGING_COMMITEE]: 'Resolution of Board or Managing Committee',
    [EntityDocumentTypes.TRUST_DEED]: 'Trust Deed',
    [IndividualDocumentTypes.LETTER_OF_ALLOTMENT_OF_ACCOMMODATION]: 'Letter of Allotment of Accommodation',
    [EntityDocumentTypes.OTHERS]: 'Others',
    [IndividualDocumentTypes.PENSION_PAYMENT_ORDERS]: 'Pension Payment Orders',
    [IndividualDocumentTypes.TAX_RECEIPT]: 'Tax Receipt',
    [IndividualDocumentTypes.UTILITY_BILL]: 'Utility Bill',
    [EntityDocumentTypes.CERTIFICATE_OF_INCORPORATION]: 'Certificate of Incorporation',
    [EntityDocumentTypes.REGISTRATION_CERTIFICATE]: 'Registration Certificate',
};

export const DOCUMENT_TYPE_TO_ID: Record<EntityDocumentTypes | IndividualDocumentTypes, string> = {
    [IndividualDocumentTypes.AADHAAR]: 'Aadhaar No.',
    [IndividualDocumentTypes.PASSPORT]: 'Passport No.',
    [IndividualDocumentTypes.DRIVING_LICENSE]: 'License No.',
    [IndividualDocumentTypes.VOTER_ID]: 'Voter No.',
    [IndividualDocumentTypes.NATIONAL_POPULATION_REGISTER_LETTER]: 'National Population Register No.',
    [IndividualDocumentTypes.NREGA_JOB_CARD]: 'NREGA Job Card No.',
    [EntityDocumentTypes.ACTIVITY_PROOF_1]: '',
    [EntityDocumentTypes.ACTIVITY_PROOF_2]: '',
    [EntityDocumentTypes.MEMORANDUM_AND_ARTICLES_OF_ASSOCIATION]: '',
    [EntityDocumentTypes.OFFICIALLY_VALID_DOCUMENT_OF_AUTHORIZED_PERSON_TO_TRANSACT]: '',
    [EntityDocumentTypes.PARTNERSHIP_DEED]: '',
    [EntityDocumentTypes.POWER_OF_ATTORNEY_TO_TRANSACT]: '',
    [EntityDocumentTypes.RESOLUTION_OF_BOARD_OR_MANAGING_COMMITEE]: '',
    [EntityDocumentTypes.TRUST_DEED]: '',
    [IndividualDocumentTypes.LETTER_OF_ALLOTMENT_OF_ACCOMMODATION]: 'Letter of Allotment No.',
    [IndividualDocumentTypes.PENSION_PAYMENT_ORDERS]: '',
    [IndividualDocumentTypes.TAX_RECEIPT]: '',
    [IndividualDocumentTypes.UTILITY_BILL]: '',
    [EntityDocumentTypes.CERTIFICATE_OF_INCORPORATION]: 'CIN',
    [EntityDocumentTypes.REGISTRATION_CERTIFICATE]: 'Registration No.',
    [EntityDocumentTypes.OTHERS]: '',
};

export const FRONT_AND_BACK_SUPPORTED_DOCUMENTS: Record<EntityDocumentTypes | IndividualDocumentTypes, boolean> = {
    [EntityDocumentTypes.CERTIFICATE_OF_INCORPORATION]: false,
    [EntityDocumentTypes.REGISTRATION_CERTIFICATE]: false,
    [IndividualDocumentTypes.AADHAAR]: true,
    [IndividualDocumentTypes.PASSPORT]: false,
    [IndividualDocumentTypes.DRIVING_LICENSE]: true,
    [IndividualDocumentTypes.VOTER_ID]: true,
    [IndividualDocumentTypes.NATIONAL_POPULATION_REGISTER_LETTER]: false,
    [IndividualDocumentTypes.NREGA_JOB_CARD]: false,
    [EntityDocumentTypes.ACTIVITY_PROOF_1]: false,
    [EntityDocumentTypes.ACTIVITY_PROOF_2]: false,
    [EntityDocumentTypes.MEMORANDUM_AND_ARTICLES_OF_ASSOCIATION]: false,
    [EntityDocumentTypes.OFFICIALLY_VALID_DOCUMENT_OF_AUTHORIZED_PERSON_TO_TRANSACT]: false,
    [EntityDocumentTypes.PARTNERSHIP_DEED]: false,
    [EntityDocumentTypes.POWER_OF_ATTORNEY_TO_TRANSACT]: false,
    [EntityDocumentTypes.RESOLUTION_OF_BOARD_OR_MANAGING_COMMITEE]: false,
    [EntityDocumentTypes.TRUST_DEED]: false,
    [IndividualDocumentTypes.LETTER_OF_ALLOTMENT_OF_ACCOMMODATION]: false,
    [EntityDocumentTypes.OTHERS]: true,
    [IndividualDocumentTypes.PENSION_PAYMENT_ORDERS]: false,
    [IndividualDocumentTypes.TAX_RECEIPT]: false,
    [IndividualDocumentTypes.UTILITY_BILL]: false,
};

export const OCR_SUPPORTED_DOCUMENTS: Record<EntityDocumentTypes | IndividualDocumentTypes, boolean> = {
    [EntityDocumentTypes.CERTIFICATE_OF_INCORPORATION]: false,
    [EntityDocumentTypes.REGISTRATION_CERTIFICATE]: false,
    [EntityDocumentTypes.OTHERS]: false,
    [IndividualDocumentTypes.AADHAAR]: true,
    [IndividualDocumentTypes.DRIVING_LICENSE]: true,
    [IndividualDocumentTypes.VOTER_ID]: true,
    [IndividualDocumentTypes.NATIONAL_POPULATION_REGISTER_LETTER]: false,
    [IndividualDocumentTypes.PASSPORT]: true,
    [IndividualDocumentTypes.NREGA_JOB_CARD]: false,
    [EntityDocumentTypes.ACTIVITY_PROOF_1]: false,
    [EntityDocumentTypes.ACTIVITY_PROOF_2]: false,
    [EntityDocumentTypes.MEMORANDUM_AND_ARTICLES_OF_ASSOCIATION]: false,
    [EntityDocumentTypes.OFFICIALLY_VALID_DOCUMENT_OF_AUTHORIZED_PERSON_TO_TRANSACT]: false,
    [EntityDocumentTypes.PARTNERSHIP_DEED]: false,
    [EntityDocumentTypes.POWER_OF_ATTORNEY_TO_TRANSACT]: false,
    [EntityDocumentTypes.RESOLUTION_OF_BOARD_OR_MANAGING_COMMITEE]: false,
    [EntityDocumentTypes.TRUST_DEED]: false,
    [IndividualDocumentTypes.LETTER_OF_ALLOTMENT_OF_ACCOMMODATION]: false,
    [IndividualDocumentTypes.PENSION_PAYMENT_ORDERS]: false,
    [IndividualDocumentTypes.TAX_RECEIPT]: false,
    [IndividualDocumentTypes.UTILITY_BILL]: false,
};

export const PROOF_OF_ADDRESS: Record<EntityDocumentTypes | IndividualDocumentTypes, boolean> = {
    [EntityDocumentTypes.CERTIFICATE_OF_INCORPORATION]: true,
    [EntityDocumentTypes.REGISTRATION_CERTIFICATE]: true,
    [IndividualDocumentTypes.AADHAAR]: true,
    [IndividualDocumentTypes.DRIVING_LICENSE]: true,
    [IndividualDocumentTypes.NATIONAL_POPULATION_REGISTER_LETTER]: true,
    [IndividualDocumentTypes.NREGA_JOB_CARD]: true,
    [IndividualDocumentTypes.VOTER_ID]: true,
    [IndividualDocumentTypes.PASSPORT]: true,
    [EntityDocumentTypes.ACTIVITY_PROOF_1]: false,
    [EntityDocumentTypes.ACTIVITY_PROOF_2]: false,
    [EntityDocumentTypes.MEMORANDUM_AND_ARTICLES_OF_ASSOCIATION]: false,
    [EntityDocumentTypes.OFFICIALLY_VALID_DOCUMENT_OF_AUTHORIZED_PERSON_TO_TRANSACT]: false,
    [EntityDocumentTypes.PARTNERSHIP_DEED]: false,
    [EntityDocumentTypes.POWER_OF_ATTORNEY_TO_TRANSACT]: false,
    [EntityDocumentTypes.RESOLUTION_OF_BOARD_OR_MANAGING_COMMITEE]: false,
    [EntityDocumentTypes.TRUST_DEED]: false,
    [IndividualDocumentTypes.LETTER_OF_ALLOTMENT_OF_ACCOMMODATION]: true,
    [EntityDocumentTypes.OTHERS]: true,
    [IndividualDocumentTypes.PENSION_PAYMENT_ORDERS]: true,
    [IndividualDocumentTypes.TAX_RECEIPT]: true,
    [IndividualDocumentTypes.UTILITY_BILL]: true,
};

export const PROOF_OF_IDENTITY: Record<EntityDocumentTypes | IndividualDocumentTypes, boolean> = {
    [EntityDocumentTypes.CERTIFICATE_OF_INCORPORATION]: true,
    [EntityDocumentTypes.REGISTRATION_CERTIFICATE]: true,
    [IndividualDocumentTypes.AADHAAR]: true,
    [IndividualDocumentTypes.DRIVING_LICENSE]: true,
    [IndividualDocumentTypes.NATIONAL_POPULATION_REGISTER_LETTER]: true,
    [IndividualDocumentTypes.NREGA_JOB_CARD]: true,
    [IndividualDocumentTypes.VOTER_ID]: true,
    [IndividualDocumentTypes.PASSPORT]: true,
    [EntityDocumentTypes.ACTIVITY_PROOF_1]: true,
    [EntityDocumentTypes.ACTIVITY_PROOF_2]: true,
    [EntityDocumentTypes.MEMORANDUM_AND_ARTICLES_OF_ASSOCIATION]: true,
    [EntityDocumentTypes.OFFICIALLY_VALID_DOCUMENT_OF_AUTHORIZED_PERSON_TO_TRANSACT]: true,
    [EntityDocumentTypes.PARTNERSHIP_DEED]: true,
    [EntityDocumentTypes.POWER_OF_ATTORNEY_TO_TRANSACT]: true,
    [EntityDocumentTypes.RESOLUTION_OF_BOARD_OR_MANAGING_COMMITEE]: true,
    [EntityDocumentTypes.TRUST_DEED]: true,
    [IndividualDocumentTypes.LETTER_OF_ALLOTMENT_OF_ACCOMMODATION]: false,
    [EntityDocumentTypes.OTHERS]: false,
    [IndividualDocumentTypes.PENSION_PAYMENT_ORDERS]: false,
    [IndividualDocumentTypes.TAX_RECEIPT]: false,
    [IndividualDocumentTypes.UTILITY_BILL]: false,
};

export const DOCUMENT_ID_NEEDED: Record<EntityDocumentTypes | IndividualDocumentTypes, boolean> = {
    [EntityDocumentTypes.CERTIFICATE_OF_INCORPORATION]: true,
    [EntityDocumentTypes.REGISTRATION_CERTIFICATE]: true,
    [IndividualDocumentTypes.AADHAAR]: true,
    [IndividualDocumentTypes.DRIVING_LICENSE]: true,
    [IndividualDocumentTypes.NATIONAL_POPULATION_REGISTER_LETTER]: true,
    [IndividualDocumentTypes.NREGA_JOB_CARD]: true,
    [IndividualDocumentTypes.VOTER_ID]: true,
    [IndividualDocumentTypes.PASSPORT]: true,
    [EntityDocumentTypes.ACTIVITY_PROOF_1]: false,
    [EntityDocumentTypes.ACTIVITY_PROOF_2]: false,
    [EntityDocumentTypes.MEMORANDUM_AND_ARTICLES_OF_ASSOCIATION]: false,
    [EntityDocumentTypes.OFFICIALLY_VALID_DOCUMENT_OF_AUTHORIZED_PERSON_TO_TRANSACT]: false,
    [EntityDocumentTypes.PARTNERSHIP_DEED]: false,
    [EntityDocumentTypes.POWER_OF_ATTORNEY_TO_TRANSACT]: false,
    [EntityDocumentTypes.RESOLUTION_OF_BOARD_OR_MANAGING_COMMITEE]: false,
    [EntityDocumentTypes.TRUST_DEED]: false,
    [IndividualDocumentTypes.LETTER_OF_ALLOTMENT_OF_ACCOMMODATION]: false,
    [EntityDocumentTypes.OTHERS]: false,
    [IndividualDocumentTypes.PENSION_PAYMENT_ORDERS]: false,
    [IndividualDocumentTypes.TAX_RECEIPT]: false,
    [IndividualDocumentTypes.UTILITY_BILL]: false,
};

export interface MatchInfoFieldTypeV2 {
    value: string;
    exactMatch: boolean;
}

export interface EntityMatchInfoV2 {
    name: MatchInfoFieldTypeV2;
    constitutionType: MatchInfoFieldTypeV2;
    age: MatchInfoFieldTypeV2;
    ckycNumber: string;
    matchingFields: string;
    kycCreatedAt: string;
    kycUpdatedAt: string;
    matched?: boolean;
    remarks?: string;
    makerName?: string;
    makerImage?: ImageInfo;
}

export interface CustomFormSelectInputType {
    label: string;
    value: string;
}

export interface PersonalDetailsV2 {
    salutation: string;
    firstName: string;
    image?: ImageInfo;
    middleName?: string;
    lastName: string;
    dob: string;
    gender: string;
    maritalStatus: string;
    nationality: string;
    pan: string;
}

export interface ContactDetailsV2 {
    mobileNumber: string;
    email: string;
}

export interface FathersDetailsV2 {
    fatherSalutation: string;
    fatherFirstName: string;
    fatherMiddleName?: string;
    fatherLastName: string;
}

export interface MothersDetailsV2 {
    motherSalutation: string;
    motherFirstName: string;
    motherMiddleName?: string;
    motherLastName: string;
}

export interface RelatedPersonFromDataV2
    extends PersonalDetailsV2,
        ContactDetailsV2,
        FathersDetailsV2,
        MothersDetailsV2,
        AddressFormDataV2 {
    relatedPersonType: string;
}

export interface GroupAAddrressV2 {
    groupAFullAddress: string;
    groupACityTownVillage: string;
    groupAPin: string;
    groupADistrict: string;
    groupAState: string;
}

export interface GroupBAddrressV2 {
    groupBFullAddress: string;
    groupBCityTownVillage: string;
    groupBPin: string;
    groupBDistrict: string;
    groupBState: string;
}

export interface AddressFormDataV2 extends GroupAAddrressV2, GroupBAddrressV2 {
    groupADataSameAsGroupBData: boolean;
}

// Individual Basic Details, Address, Related Person - start here
export interface IndividualFormDataV2 extends PersonalDetailsV2, FathersDetailsV2, MothersDetailsV2, AddressFormDataV2 {
    relatedPersons: RelatedPersonFromDataV2;
}

// Enitity Basic Details, Address, Related Person - start here
export interface EnitityDetailsV2 {
    name: string;
    entityConstitutionType: string;
    doi: string;
    poi: string;
    coi: string;
    doCoB: string;
    pan: string;
    tinGstNumber: string;
    tinIssuingCountry: string;
}

export interface EntityFormDataV2 extends EnitityDetailsV2, ContactDetailsV2, AddressFormDataV2 {
    relatedPersons: RelatedPersonFromDataV2[];
}
// Enitity Basic Details, Address, Related Person - end here

export interface CkycData {
    component: StpFailureComponent;
    ckyc_value: string;
    original_value: string;
}

export interface OtherSourceDataItemV2 {
    source?: string | undefined;
    value?: Gender | Salutation | string | undefined;
    isInvalidData?: boolean;
}

export interface OtherSourceDataRenderer {
    // setData: (data: string | undefined) => void;
    readOnly?: boolean;
    isSelect?: boolean;
    otherDataValue: OtherSourceDataItemV2;
}

export interface ConfirmMatchDataType {
    label: string;
    value: string;
}

export interface ConfirmMatchData {
    customerPhoto: ConfirmMatchDataType;
    customerName: ConfirmMatchDataType;
    customerAge: ConfirmMatchDataType;
    fatherSpouseName: ConfirmMatchDataType;
    all: ConfirmMatchDataType;
}

export interface EntityProbableMatchData {
    entityName: ConfirmMatchDataType;
    constitutionType: ConfirmMatchDataType;
    entityAge: ConfirmMatchDataType;
    all: ConfirmMatchDataType;
}

export enum EntityConstitutionTypes {
    SOLE_PROPRIETORSHIP = 'sole_proprietorship',
    PARTNERSHIP_FIRM = 'partnership_firm',
    HUF = 'huf',
    PRIVATE_LIMITED_COMPANY = 'private_limited_company',
    PUBLIC_LIMITED_COMPANY = 'public_limited_company',
    SOCIETY = 'society',
    ASSOCIATION_OF_PERSONS_BODY_OF_INDIVIDUALS = 'body_of_individuals',
    TRUST = 'trust',
    LIQUIDATOR = 'liquidator',
    LIMITED_LIABILITY_PARTNERSHIP = 'limited_liability_partnership',
    ARTIFICIAL_LIABILITY_PARTNERSHIP = 'artificial_liability_partnership',
    PUBLIC_SECTOR_BANKS = 'public_sector_banks',
    CENTRAL_STATE_GOVERNMENT_DEPARTMENTS_AGENCY = 'central_or_state_government_departments_or_agency',
    SECTION_8 = 'section_8_companies',
    ARTIFICIAL_JURIDICAL_PERSON = 'artificial_juridical_person',
    INTERNATIONAL_ORGANISATION_OR_AGENCY_FOREIGN_EMBASSSY_OR_CONSULAR_OFFICE_ETC = 'international_agency',
    NOT_CATEGORIZED = 'not_categorized',
    OTHERS = 'others',
    FOREIGN_PORTFOLIO_INVESTORS = 'foreign_portfolio_investors',
    INDIVIDUAL = 'individual',
}

export const NO_FORM60_ENTITY_TYPES: EntityConstitutionTypes[] = [
    EntityConstitutionTypes.PARTNERSHIP_FIRM,
    EntityConstitutionTypes.PRIVATE_LIMITED_COMPANY,
    EntityConstitutionTypes.PUBLIC_LIMITED_COMPANY,
    EntityConstitutionTypes.SECTION_8,
    EntityConstitutionTypes.LIMITED_LIABILITY_PARTNERSHIP,
    EntityConstitutionTypes.ARTIFICIAL_LIABILITY_PARTNERSHIP,
    EntityConstitutionTypes.PUBLIC_SECTOR_BANKS,
];

export enum KycAccountType {
    NORMAL = 'NORMAL',
    OTP_BASED = 'OTP_BASED',
    MINOR = 'MINOR',
}

export enum KycDocumentType {
    CERTIFIED_COPIES = 'CERTIFIED_COPIES',
    E_KYC_DATA_RECEIVED_FROM_UIDAI = 'E_KYC_DATA_RECEIVED_FROM_UIDAI',
    DATA_RECEIVED_FROM_OFFLINE_VERIFICATION = 'DATA_RECEIVED_FROM_OFFLINE_VERIFICATION',
    DIGITAL_KYC_PROCESS = 'DIGITAL_KYC_PROCESS',
    EQUIVALENT_E_DOCUMENT = 'EQUIVALENT_E_DOCUMENT',
    VIDEO_BASED_KYC = 'VIDEO_BASED_KYC',
}

export const KYC_DOCUMENT_TYPE_TO_LABEL: Record<KycDocumentType, string> = {
    [KycDocumentType.CERTIFIED_COPIES]: 'Certified Copies',
    [KycDocumentType.E_KYC_DATA_RECEIVED_FROM_UIDAI]: 'E-KYC Data received from UIDAI',
    [KycDocumentType.DATA_RECEIVED_FROM_OFFLINE_VERIFICATION]: 'Data received from offline verification',
    [KycDocumentType.DIGITAL_KYC_PROCESS]: 'Digital KYC process',
    [KycDocumentType.EQUIVALENT_E_DOCUMENT]: 'Equivalent e-document',
    [KycDocumentType.VIDEO_BASED_KYC]: 'Video-based KYC',
};

export const KYC_ACCOUNT_TYPE_TO_LABEL: Record<KycAccountType, string> = {
    [KycAccountType.MINOR]: 'Minor',
    [KycAccountType.NORMAL]: 'Normal',
    [KycAccountType.OTP_BASED]: 'Otp Based',
};

export const KYC_DOCUMENT_TYPE_INDIVIDUAL = Object.values(KycDocumentType)?.map((value) => ({
    label: KYC_DOCUMENT_TYPE_TO_LABEL[value],
    value: value,
}));

export const KYC_ACCOUNT_TYPE = Object.values(KycAccountType)?.map((value) => ({
    label: KYC_ACCOUNT_TYPE_TO_LABEL[value],
    value: value,
}));

export const KYC_DOCUMENT_TYPE_ENTITY = [
    { label: KYC_DOCUMENT_TYPE_TO_LABEL[KycDocumentType.CERTIFIED_COPIES], value: KycDocumentType.CERTIFIED_COPIES },
    {
        label: KYC_DOCUMENT_TYPE_TO_LABEL[KycDocumentType.EQUIVALENT_E_DOCUMENT],
        value: KycDocumentType.EQUIVALENT_E_DOCUMENT,
    },
];

export const ENTITY_CONSTITUTION_TYPE_TO_LABEL: Record<EntityConstitutionTypes, string> = {
    [EntityConstitutionTypes.SOLE_PROPRIETORSHIP]: 'SOLE PROPRIETORSHIP',
    [EntityConstitutionTypes.PARTNERSHIP_FIRM]: 'PARTNERSHIP FIRM',
    [EntityConstitutionTypes.HUF]: 'HUF',
    [EntityConstitutionTypes.PRIVATE_LIMITED_COMPANY]: 'PRIVATE LIMITED COMPANY',
    [EntityConstitutionTypes.PUBLIC_LIMITED_COMPANY]: 'PUBLIC LIMITED COMPANY',
    [EntityConstitutionTypes.SOCIETY]: 'SOCIETY',
    [EntityConstitutionTypes.ASSOCIATION_OF_PERSONS_BODY_OF_INDIVIDUALS]:
        'ASSOCIATION OF PERSONS (AOP)/ BODY OF INDIVIDUALS (BOI)',
    [EntityConstitutionTypes.TRUST]: 'TRUST',
    [EntityConstitutionTypes.LIQUIDATOR]: 'LIQUIDATOR',
    [EntityConstitutionTypes.LIMITED_LIABILITY_PARTNERSHIP]: 'LIMITED LIABILITY PARTNERSHIP',
    [EntityConstitutionTypes.ARTIFICIAL_LIABILITY_PARTNERSHIP]: 'ARTIFICIAL LIABILITY PARTNERSHIP',
    [EntityConstitutionTypes.PUBLIC_SECTOR_BANKS]: 'PUBLIC SECTOR BANKS',
    [EntityConstitutionTypes.CENTRAL_STATE_GOVERNMENT_DEPARTMENTS_AGENCY]:
        'CENTRAL/STATE GOVERNMENT DEPARTMENTS/AGENCY',
    [EntityConstitutionTypes.SECTION_8]: 'SECTION 8 (COMPANIES ACT, 2013)',
    [EntityConstitutionTypes.ARTIFICIAL_JURIDICAL_PERSON]: 'ARTIFICIAL JURIDICAL PERSON',
    [EntityConstitutionTypes.INTERNATIONAL_ORGANISATION_OR_AGENCY_FOREIGN_EMBASSSY_OR_CONSULAR_OFFICE_ETC]:
        'INTERNATIONAL ORGANISATION OR AGENCY/FOREIGN EMBASSSY OR CONSULAR OFFICE ETC.',
    [EntityConstitutionTypes.NOT_CATEGORIZED]: 'NOT CATEGORIZED',
    [EntityConstitutionTypes.OTHERS]: 'OTHERS',
    [EntityConstitutionTypes.FOREIGN_PORTFOLIO_INVESTORS]: 'FOREIGN PORTFOLIO INVESTORS',
    [EntityConstitutionTypes.INDIVIDUAL]: 'INDIVIDUAL',
};

// changes for backend
export interface ParentDetail {
    salutation?: string;
    firstName?: string;
    middleName?: string;
    lastName?: string;
}

export interface StpFailureReasons {
    component: StpFailureComponent;
    value: string;
}

export enum IsFatherOrSpouse {
    FATHER = 'father',
    SPOUSE = 'spouse',
}

export interface IndividualDetails {
    isChecker?: boolean;
    taskType: TaskTypeV2;
    taskUserType: TaskUserTypeV2;
    salutation: string;
    firstName: string;
    image?: ImageInfo;
    middleName?: string;
    lastName: string;
    dob: string;
    gender: string;
    maritalStatus?: string;
    nationality?: string;
    panNumber: string;
    accountType: KycAccountType;
    cif: string;
    losAppId?: string;
    dateOfDeclaration?: string;
    placeOfDeclaration?: string;
    isPermanentAddressSameAsCurrentAddress: boolean;
    permanentAddressDocumentType?: IndividualDocumentTypes | string;
    currentAddressDocumentType?: IndividualDocumentTypes | string;
    permanentAddress: Address;
    currentAddress: Address;
    email: string;
    isFatherOrSpouseName: IsFatherOrSpouse;
    motherDetails?: ParentDetail;
    fatherDetails?: ParentDetail;
    kycDocuments?: KycDocuments[];
    documentTypeMaster: string;
    relatedPerson?: RelatedPersonDetail[];
    mobileNumber: string;
    country: string;
    checkerRemarks?: string;
    stpFailureReasons?: Partial<Record<StpFailureComponent, string>>;
    makerName?: string;
    ckycRejected?: string;
    ckycRejectionReason?: string;
    differentlyAbledStatusFlag?: string;
    typeOfImpairment?: string;
    percentageOfImpairment?: string;
    udidNumber?: string;
}
export interface RelatedPersonDetail {
    relatedPersonDetails: {
        documentTypeMaster?: string;
        additionOrDeletionOfRelatedPerson: 'ADD' | 'EXISTING';
        salutation: string;
        firstName: string;
        image?: ImageInfo;
        middleName?: string;
        lastName: string;
        dob: string;
        gender: string;
        maritalStatus?: string;
        nationality?: string;
        panNumber: string;
        mobileNumber: string;
        dateOfDeclaration?: string;
        placeOfDeclaration?: string;
        isFatherOrSpouseName: IsFatherOrSpouse;
        country: string;
        isPermanentAddressSameAsCurrentAddress: boolean;
        permanentAddress: Address;
        currentAddress: Address;
        email: string;
        motherDetails?: ParentDetail;
        fatherDetails?: ParentDetail;
        kycDocuments?: KycDocuments[];
        currentAddressProofMaster?: IndividualDocumentTypes | EntityDocumentTypes | string;
        permanentAddressProofMaster?: IndividualDocumentTypes | EntityDocumentTypes | string;
        relatedPersonDifferentlyAbledStatusFlag?: string;
        relatedPersonTypeOfImpairment?: string;
        relatedPersonPercentageOfImpairment?: string;
        relatedPersonUdidNumber?: string;
    };
    relatedPersonType?: RelatedPersonType;
    relatedPersonTypeDescription?: string;
    DIN?: string;
}
export interface Address {
    fullAddress: string;
    cityTownVillage: string;
    pinCode: string;
    district: string;
    state: string;
}
export interface EntityDetails {
    isChecker?: boolean;
    taskType: TaskTypeV2;
    taskUserType: TaskUserTypeV2;
    cif: string;
    losAppId?: string;
    name?: string;
    email: string;
    mobileNumber: string;
    entityConstitutionType: string;
    constitutionTypeDescription: string;
    dateOfIncorporation: string;
    placeOfIncorporation: string;
    countryOfIncorporation: string;
    dateOfCommencementOfBusiness: string;
    dateOfDeclaration?: string;
    placeOfDeclaration?: string;
    gstNumber: string;
    tinIssuingCountry: string;
    panNumber: string;
    registeredAddressDocumentType?: EntityDocumentTypes | string;
    registeredAddressDocumentTypeDescription: string;
    localAddressDocumentType?: EntityDocumentTypes | string;
    registeredAddress: Address;
    localAddress: Address;
    isRegisteredAddressSameAsLocalAddress: boolean;
    relatedPerson?: RelatedPersonDetail[];
    kycDocuments?: KycDocuments[];
    documentTypeMaster: string;
    checkerRemarks?: string;
    stpFailureReasons?: Partial<Record<StpFailureComponent, string>>;
    makerName?: string;
    ckycRejected?: string;
    ckycRejectionReason?: string;
}

export interface ProbableMatchImage {
    image: string;
    matchPercent: string;
}

export interface ProbableMatchIndividualOptionV2 {
    photograph: ProbableMatchImage;
    name: string;
    age: string;
    fatherSpouseName: string;
    ckycNumber: string;
    matchingFields: string;
    kycCreatedAt: string;
    kycUpdatedAt: string;
    matchScore: string;
    matched?: boolean;
    remarks?: string;
}

export interface ProbableMatchEntityOptionV2 {
    name: string;
    age: string;
    constitutionType: string;
    ckycNumber: string;
    matchingFields: string;
    kycCreatedAt: string;
    kycUpdatedAt: string;
    matched?: boolean;
    remarks?: string;
}
export interface ProbableMatchIndividualV2 {
    photograph: string;
    name: string;
    age: string;
    fatherSpouseName: string;
    referenceNumber: string;
    kycDate: string;
    losAppId?: string;
    probableMatches: ProbableMatchIndividualOptionV2[];
    checkerRemarks?: string;
    makerRemarks?: string;
    makerName?: string;
    makerImage?: ImageInfo;
    NM: boolean;
}
export interface ProbableMatchEntityV2 {
    name: string;
    age: string;
    constitutionType: string;
    placeOfIncorporation: string;
    dateOfIncorporation: string;
    referenceNumber: string;
    kycDate: string;
    losAppId?: string;
    probableMatches: ProbableMatchEntityOptionV2[];
    checkerRemarks?: string;
    makerRemarks?: string;
    makerName?: string;
    makerImage?: ImageInfo;
    NM: boolean;
}

export enum StpFailureComponent {
    SALUTATION = 'SALUTATION',
    PHOTO = 'PHOTO',
    FIRST_NAME = 'FIRST_NAME',
    MIDDLE_NAME = 'MIDDLE_NAME',
    LAST_NAME = 'LAST_NAME',
    NAME = 'NAME',
    DOB = 'DOB',
    PAN = 'PAN',
    GENDER = 'GENDER',
    FATHER_SALUTATION = 'FATHER_SALUTATION',
    FATHER_FIRST_NAME = 'FATHER_FIRST_NAME',
    FATHER_MIDDLE_NAME = 'FATHER_MIDDLE_NAME',
    FATHER_LAST_NAME = 'FATHER_LAST_NAME',
    MOTHER_SALUTATION = 'MOTHER_SALUTATION',
    MOTHER_FIRST_NAME = 'MOTHER_FIRST_NAME',
    MOTHER_MIDDLE_NAME = 'MOTHER_MIDDLE_NAME',
    MOTHER_LAST_NAME = 'MOTHER_LAST_NAME',
    PERMANENT_ADDRESS_FLAG = 'PERMANENT_ADDRESS_FLAG',
    PERMANENT_ADDRESS = 'PERMANENT_ADDRESS',
    PERMANENT_ADDRESS_CITY = 'PERMANENT_ADDRESS_CITY',
    PERMANENT_ADDRESS_STATE = 'PERMANENT_ADDRESS_STATE',
    PERMANENT_ADDRESS_DISTRICT = 'PERMANENT_ADDRESS_DISTRICT',
    PERMANENT_ADDRESS_PINCODE = 'PERMANENT_ADDRESS_PINCODE',
    PERMANENT_ADDRESS_PROOF = 'PERMANENT_ADDRESS_PROOF',
    CURRENT_ADDRESS = 'CURRENT_ADDRESS',
    CURRENT_ADDRESS_CITY = 'CURRENT_ADDRESS_CITY',
    CURRENT_ADDRESS_STATE = 'CURRENT_ADDRESS_STATE',
    CURRENT_ADDRESS_DISTRICT = 'CURRENT_ADDRESS_DISTRICT',
    CURRENT_ADDRESS_PINCODE = 'CURRENT_ADDRESS_PINCODE',
    CURRENT_ADDRESS_PROOF = 'CURRENT_ADDRESS_PROOF',
    MOBILE = 'MOBILE',
    KYC_TYPE = 'KYC_TYPE',
    KYC_COMPLETED_DATE = 'KYC_COMPLETED_DATE',
    KYC_LOCATION = 'KYC_LOCATION',
    PROOF_DOCUMENT_ID = 'PROOF_DOCUMENT_ID',
    PROOF_DOCUMENT_TYPE = 'PROOF_DOCUMENT_TYPE',
    DATE_OF_INCORPORATION = 'DATE_OF_INCORPORATION',
    DATE_OF_COMMENCEMENT_OF_BUSINESS = 'DATE_OF_COMMENCEMENT_OF_BUSINESS',
    DATE_OF_GST_REGISTRATION_DATE = 'DATE_OF_GST_REGISTRATION_DATE',
    DATE_OF_DECLARATION_DATE = 'DATE_OF_DECLARATION_DATE',
    PLACE_OF_INCORPORATION = 'PLACE_OF_INCORPORATION',
    REGISTERED_ADDRESS = 'REGISTERED_ADDRESS',
    REGISTERED_ADDRESS_CITY = 'REGISTERED_ADDRESS_CITY',
    REGISTERED_ADDRESS_STATE = 'REGISTERED_ADDRESS_STATE',
    REGISTERED_ADDRESS_DISTRICT = 'REGISTERED_ADDRESS_DISTRICT',
    REGISTERED_ADDRESS_PINCODE = 'REGISTERED_ADDRESS_PINCODE',
    REGISTERED_ADDRESS_PROOF = 'REGISTERED_ADDRESS_PROOF',
    REGISTERED_ADDRESS_FLAG = 'REGISTERED_ADDRESS_FLAG',
    LOCAL_ADDRESS = 'LOCAL_ADDRESS',
    LOCAL_ADDRESS_CITY = 'LOCAL_ADDRESS_CITY',
    LOCAL_ADDRESS_STATE = 'LOCAL_ADDRESS_STATE',
    LOCAL_ADDRESS_DISTRICT = 'LOCAL_ADDRESS_DISTRICT',
    LOCAL_ADDRESS_PINCODE = 'LOCAL_ADDRESS_PINCODE',
    LOCAL_ADDRESS_PROOF = 'LOCAL_ADDRESS_PROOF',
    RELATED_FIRST_NAME = 'RELATED_FIRST_NAME',
    RELATED_LAST_NAME = 'RELATED_LAST_NAME',
    RELATED_NAME = 'RELATED_NAME',
    RELATED_DOB = 'RELATED_DOB',
    RELATED_PAN = 'RELATED_PAN',
    RELATED_GENDER = 'RELATED_GENDER',
    RELATED_FATHER_FIRST_NAME = 'RELATED_FATHER_FIRST_NAME',
    RELATED_FATHER_LAST_NAME = 'RELATED_FATHER_LAST_NAME',
    RELATED_MOTHER_FIRST_NAME = 'RELATED_MOTHER_FIRST_NAME',
    RELATED_MOTHER_LAST_NAME = 'RELATED_MOTHER_LAST_NAME',
    RELATED_PERMANENT_ADDRESS = 'RELATED_PERMANENT_ADDRESS',
    RELATED_PERMANENT_ADDRESS_CITY = 'RELATED_PERMANENT_ADDRESS_CITY',
    RELATED_PERMANENT_ADDRESS_DISTRICT = 'RELATED_PERMANENT_ADDRESS_DISTRICT',
    RELATED_PERMANENT_ADDRESS_PINCODE = 'RELATED_PERMANENT_ADDRESS_PINCODE',
    RELATED_PERMANENT_ADDRESS_PROOF = 'RELATED_PERMANENT_ADDRESS_PROOF',
    RELATED_PERMANENT_ADDRESS_FLAG = 'RELATED_PERMANENT_ADDRESS_FLAG',
    RELATED_CURRENT_ADDRESS = 'RELATED_CURRENT_ADDRESS',
    RELATED_CURRENT_ADDRESS_CITY = 'RELATED_CURRENT_ADDRESS_CITY',
    RELATED_CURRENT_ADDRESS_DISTRICT = 'RELATED_CURRENT_ADDRESS_DISTRICT',
    RELATED_CURRENT_ADDRESS_PINCODE = 'RELATED_CURRENT_ADDRESS_PINCODE',
    RELATED_CURRENT_ADDRESS_PROOF = 'RELATED_CURRENT_ADDRESS_PROOF',
    RELATED_ADDRESS_DOCUMENT_ID = 'RELATED_ADDRESS_DOCUMENT_ID',
    RELATED_ADDRESS_DOCUMENT_TYPE = 'RELATED_ADDRESS_DOCUMENT_TYPE',
    RELATED_ADDRESS_PROOF = 'RELATED_ADDRESS_PROOF',
    RELATED_PROOF_DOCUMENT = 'RELATED_PROOF_DOCUMENT',
    RELATED_PERSON_TYPE = 'RELATED_PERSON_TYPE',
    RELATED_KYC_TYPE = 'RELATED_KYC_TYPE',
    PERCENTAGE_OF_IMPAIRMENT = 'PERCENTAGE_OF_IMPAIRMENT',
    UDID_NUMBER = 'UDID_NUMBER',
    TYPE_OF_IMPAIRMENT = 'TYPE_OF_IMPAIRMENT',
    RELATED_PERSON_DIFFERENTLY_ABLED_STATUS_FLAG = 'RELATED_PERSON_DIFFERENTLY_ABLED_STATUS_FLAG',
    RELATED_PERSON_PERCENTAGE_OF_IMPAIRMENT = 'RELATED_PERSON_PERCENTAGE_OF_IMPAIRMENT',
    RELATED_PERSON_TYPE_OF_IMPAIRMENT = 'RELATED_PERSON_TYPE_OF_IMPAIRMENT',
    RELATED_PERSON_UDID_NUMBER = 'RELATED_PERSON_UDID_NUMBER',
}

export const ADDRESS_COMPONENTS: StpFailureComponent[] = [
    StpFailureComponent.CURRENT_ADDRESS,
    StpFailureComponent.CURRENT_ADDRESS_CITY,
    StpFailureComponent.CURRENT_ADDRESS_STATE,
    StpFailureComponent.CURRENT_ADDRESS_DISTRICT,
    StpFailureComponent.CURRENT_ADDRESS_PINCODE,
    StpFailureComponent.PERMANENT_ADDRESS,
    StpFailureComponent.PERMANENT_ADDRESS_CITY,
    StpFailureComponent.PERMANENT_ADDRESS_STATE,
    StpFailureComponent.PERMANENT_ADDRESS_DISTRICT,
    StpFailureComponent.PERMANENT_ADDRESS_PINCODE,
    StpFailureComponent.LOCAL_ADDRESS,
    StpFailureComponent.LOCAL_ADDRESS_CITY,
    StpFailureComponent.LOCAL_ADDRESS_STATE,
    StpFailureComponent.LOCAL_ADDRESS_DISTRICT,
    StpFailureComponent.LOCAL_ADDRESS_PINCODE,
    StpFailureComponent.REGISTERED_ADDRESS,
    StpFailureComponent.REGISTERED_ADDRESS_CITY,
    StpFailureComponent.REGISTERED_ADDRESS_STATE,
    StpFailureComponent.REGISTERED_ADDRESS_DISTRICT,
    StpFailureComponent.REGISTERED_ADDRESS_PINCODE,
    // StpFailureComponent.PERMANENT_ADDRESS_FLAG,
    // StpFailureComponent.REGISTERED_ADDRESS_FLAG,
    StpFailureComponent.PERMANENT_ADDRESS_PROOF,
    StpFailureComponent.REGISTERED_ADDRESS_PROOF,
    StpFailureComponent.LOCAL_ADDRESS_PROOF,
    StpFailureComponent.CURRENT_ADDRESS_PROOF,
];

export const RELATED_PERSON_COMPONENTS: StpFailureComponent[] = [
    StpFailureComponent.RELATED_NAME,
    StpFailureComponent.RELATED_FIRST_NAME,
    StpFailureComponent.RELATED_LAST_NAME,
    StpFailureComponent.RELATED_DOB,
    StpFailureComponent.RELATED_PAN,
    StpFailureComponent.RELATED_GENDER,
    StpFailureComponent.RELATED_FATHER_FIRST_NAME,
    StpFailureComponent.RELATED_FATHER_LAST_NAME,
    StpFailureComponent.RELATED_PERMANENT_ADDRESS,
    StpFailureComponent.RELATED_PERMANENT_ADDRESS_CITY,
    StpFailureComponent.RELATED_PERMANENT_ADDRESS_DISTRICT,
    StpFailureComponent.RELATED_PERMANENT_ADDRESS_PINCODE,
    StpFailureComponent.RELATED_PERMANENT_ADDRESS_PROOF,
    // StpFailureComponent.RELATED_PERMANENT_ADDRESS_FLAG,
    StpFailureComponent.RELATED_CURRENT_ADDRESS,
    StpFailureComponent.RELATED_CURRENT_ADDRESS_CITY,
    StpFailureComponent.RELATED_CURRENT_ADDRESS_DISTRICT,
    StpFailureComponent.RELATED_CURRENT_ADDRESS_PINCODE,
    StpFailureComponent.RELATED_CURRENT_ADDRESS_PROOF,
    StpFailureComponent.RELATED_ADDRESS_DOCUMENT_ID,
    StpFailureComponent.RELATED_ADDRESS_DOCUMENT_TYPE,
    StpFailureComponent.RELATED_ADDRESS_PROOF,
    StpFailureComponent.RELATED_PROOF_DOCUMENT,
    StpFailureComponent.RELATED_KYC_TYPE,
    StpFailureComponent.RELATED_PERSON_DIFFERENTLY_ABLED_STATUS_FLAG,
    StpFailureComponent.RELATED_PERSON_PERCENTAGE_OF_IMPAIRMENT,
    StpFailureComponent.RELATED_PERSON_TYPE_OF_IMPAIRMENT,
    StpFailureComponent.RELATED_PERSON_UDID_NUMBER,
];

export const PROOF_COMPONENTS: StpFailureComponent[] = [
    StpFailureComponent.PERMANENT_ADDRESS_PROOF,
    StpFailureComponent.CURRENT_ADDRESS_PROOF,
    StpFailureComponent.PROOF_DOCUMENT_ID,
    StpFailureComponent.PROOF_DOCUMENT_TYPE,
];

export enum RelatedPersonType {
    GUARDIAN_OF_MINOR = 'GUARDIAN_OF_MINOR',
    ASSIGNEE = 'ASSIGNEE',
    AUTHORISED_REPRESENTATIVE = 'AUTHORISED_REPRESENTATIVE',
    DIRECTOR = 'DIRECTOR',
    PROMOTER = 'PROMOTER',
    KARTA = 'KARTA',
    TRUSTEE = 'TRUSTEE',
    PARTNER = 'PARTNER',
    PROPRIETOR = 'PROPRIETOR',
    COURT_APPOINTED_OFFICIAL = 'COURT_APPOINTED_OFFICIAL',
    BENEFICIARY = 'BENEFICIARY',
    AUTHORISED_SIGNATORY = 'AUTHORISED_SIGNATORY',
    BENEFICIAL_OWNER = 'BENEFICIAL_OWNER',
    POWER_OF_ATTORNEY_HOLDER = 'POWER_OF_ATTORNEY_HOLDER',
    OTHERS = 'OTHER',
}

export const INDIVIDUAL_RELATED_PERSON_TYPES: RelatedPersonType[] = [
    RelatedPersonType.GUARDIAN_OF_MINOR,
    RelatedPersonType.ASSIGNEE,
    RelatedPersonType.AUTHORISED_REPRESENTATIVE,
];

export const ENTITY_RELATED_PERSON_TYPES: RelatedPersonType[] = [
    RelatedPersonType.DIRECTOR,
    RelatedPersonType.PROMOTER,
    RelatedPersonType.KARTA,
    RelatedPersonType.TRUSTEE,
    RelatedPersonType.PARTNER,
    RelatedPersonType.PROPRIETOR,
    RelatedPersonType.COURT_APPOINTED_OFFICIAL,
    RelatedPersonType.BENEFICIARY,
    RelatedPersonType.AUTHORISED_SIGNATORY,
    RelatedPersonType.BENEFICIAL_OWNER,
    RelatedPersonType.POWER_OF_ATTORNEY_HOLDER,
];

export const RELATED_PERSON_TYPE_TO_LABEL: Record<RelatedPersonType, string> = {
    [RelatedPersonType.DIRECTOR]: 'Director',
    [RelatedPersonType.ASSIGNEE]: 'Assignee',
    [RelatedPersonType.AUTHORISED_REPRESENTATIVE]: 'Authorised Representative',
    [RelatedPersonType.AUTHORISED_SIGNATORY]: 'Authorised Signatory',
    [RelatedPersonType.BENEFICIAL_OWNER]: 'Beneficial Owner',
    [RelatedPersonType.GUARDIAN_OF_MINOR]: 'Guardian Of Minor',
    [RelatedPersonType.PROMOTER]: 'Promoter',
    [RelatedPersonType.KARTA]: 'Karta',
    [RelatedPersonType.TRUSTEE]: 'Trustee',
    [RelatedPersonType.PARTNER]: 'Partner',
    [RelatedPersonType.PROPRIETOR]: 'Proprietor',
    [RelatedPersonType.COURT_APPOINTED_OFFICIAL]: 'Court Appointed Official',
    [RelatedPersonType.BENEFICIARY]: 'Beneficiary',
    [RelatedPersonType.POWER_OF_ATTORNEY_HOLDER]: 'Power Of Attorney',
    [RelatedPersonType.OTHERS]: 'Others',
};

export const RELATED_PERSON_TYPE_INDIVIDUAL = Object.values(RelatedPersonType)
    ?.filter((value) => INDIVIDUAL_RELATED_PERSON_TYPES.includes(value))
    .map((value) => ({
        label: RELATED_PERSON_TYPE_TO_LABEL[value],
        value: value,
    }));

export const RELATED_PERSON_TYPE_ENTITY = Object.values(RelatedPersonType)
    ?.filter((value) => !INDIVIDUAL_RELATED_PERSON_TYPES.includes(value))
    .map((value) => ({
        label: RELATED_PERSON_TYPE_TO_LABEL[value],
        value: value,
    }));

export enum REQUIRED_FIELDS {
    FIRST_NAME = 'firstName',
    NAME = 'name',
    DOB = 'dob',
    MOBILE_NUMBER = 'mobileNumber',
    PAN_NUMBER = 'panNumber',
    ACCOUNT_TYPE = 'accountType',
    GENDER = 'gender',
    FULL_ADDRESS = 'fullAddress',
    CITY_TOWN_VILLAGE = 'cityTownVillage',
    STATE = 'state',
    PIN_CODE = 'pinCode',
    DISTRICT = 'district',
    ENTITY_CONSTITUTION_TYPE = 'entityConstitutionType',
    DATE_OF_INCORPORATION = 'dateOfIncorporation',
    PLACE_OF_INCORPORATION = 'placeOfIncorporation',
    COUNTRY_OF_INCORPORATION = 'countryOfIncorporation',
    PERMANENT_ADDRESS_PROOF_TYPES = 'permanentAddressDocumentType',
    CURRENT_ADDRESS_PROOF_TYPE = 'currentAddressDocumentType',
    REGISTERED_ADDRESS_PROOF_TYPE = 'registeredAddressDocumentType',
    LOCAL_ADDRESS_PROOF_TYPE = 'localAddressDocumentType',
    RELATED_PERSON_PERMANENT_ADDRESS_PROOF_TYPE = 'permanentAddressProofMaster',
    RELATED_PERSON_CURRENT_ADDRESS_PROOF_TYPE = 'currentAddressProofMaster',
}

export const REQUIRED_TEXT_FIELD: REQUIRED_FIELDS[] = [
    REQUIRED_FIELDS.FIRST_NAME,
    REQUIRED_FIELDS.NAME,
    REQUIRED_FIELDS.DOB,
    REQUIRED_FIELDS.MOBILE_NUMBER,
    REQUIRED_FIELDS.PAN_NUMBER,
    REQUIRED_FIELDS.GENDER,
    REQUIRED_FIELDS.FULL_ADDRESS,
    REQUIRED_FIELDS.STATE,
    REQUIRED_FIELDS.CITY_TOWN_VILLAGE,
    REQUIRED_FIELDS.PIN_CODE,
    REQUIRED_FIELDS.DISTRICT,
    REQUIRED_FIELDS.ENTITY_CONSTITUTION_TYPE,
    REQUIRED_FIELDS.DATE_OF_INCORPORATION,
    REQUIRED_FIELDS.PLACE_OF_INCORPORATION,
    REQUIRED_FIELDS.COUNTRY_OF_INCORPORATION,
];

export interface DAFAddress {
    address: string;
    city: string;
    district: string;
    pinCode: string;
    documentType: string;
}

export interface CkycSearchPayload {
    addressPinCode: string;
    cif: string;
    ckycNumber: string;
    ckycOperationId: string;
    dateOfBirth: string;
    fullName: string;
    gender: string;
    loanNumber: string;
    mobileNumber: string;
    searchDocumentTypes: string;
    searchIdentifier: string;
    yearOfBirth: string;
}

export interface CkycSearchResults {
    ckycNumber: string;
    fullName: string;
    fatherName: string | null;
    placeOfIncorporation: string | null;
    constitutionType: string | null;
    age: string;
    imageType: string | null;
    kycDate: string;
    updateDate: string;
    photo: string | null;
    remarks?: string;
}

export interface DAFDocumentData {
    documentId: string;
    documentModelList: documents;
    documentType: string;
}

export interface DownloadAuthFailure {
    searchPayload: CkycSearchPayload;
    searchResult: CkycSearchResults;
    currentAddress: DAFAddress;
    permanentAddress: DAFAddress;
    documents: KycDocuments[];
    errorMessage: string;
    userType: 'entity' | 'individual';
}

export interface DocumentObjectValidation {
    documentName: string;
    documentType: EntityDocumentTypes | IndividualDocumentTypes;
    isIdentifierNeeded: boolean;
    isDocumentNeeded: boolean;
    isValidForPOA: boolean;
    isValidForPOI: boolean;
    isMandatory: boolean;
    isDescriptionNeeded: boolean;
    isPermanentAddressValid: boolean;
    isCurrentAddressValid: boolean;
    isRegisteredAddressValid: boolean;
    isLocalAddressValid: boolean;
    isRelatedPermanentAddressValid: boolean;
    isRelatedCurrentAddressValid: boolean;
}

// user management

export interface UserInfo extends TableRow {
    userName: string;
    firstName: string;
    lastName: string;
    roles: string[];
    createdAt: string;
}

export type SearchUsersResults = PaginatedResults<UserInfo>;

export const NO_TASKS_ACCESS = 'NO_TASKS_ACCESS';

export const EXTERNAL_ROLE_PREFIX = 'external_';

export const CLIENT_PREFIX = 'client_';

export const CKYC_ADMIN_ROLE = 'ckycAdmin';
export const CKYC_MAKER_ROLE = 'ckycdocChecker';
export const CKYC_TASK_MAKER_ROLE = 'createTaskMaker';
export const CKYC_CHECKER_ROLE = 'ckycdocVerifier';
export const CKYC_TASK_CHECKER_ROLE = 'createTaskChecker';

export const CKYC_ADMIN_ROLES = [CKYC_ADMIN_ROLE];
export const CKYC_MAKER_ROLES = [CKYC_MAKER_ROLE, CKYC_TASK_MAKER_ROLE];
export const CKYC_CHECKER_ROLES = [CKYC_CHECKER_ROLE, CKYC_TASK_CHECKER_ROLE];

export const EXTERNAL_ADMIN_ROLES = CKYC_ADMIN_ROLES.map((each) => `${EXTERNAL_ROLE_PREFIX}${each}`);
export const EXTERNAL_MAKER_ROLES = CKYC_MAKER_ROLES.map((each) => `${EXTERNAL_ROLE_PREFIX}${each}`);
export const EXTERNAL_CHECKER_ROLES = CKYC_CHECKER_ROLES.map((each) => `${EXTERNAL_ROLE_PREFIX}${each}`);

export const ADMIN_ROLES = [...CKYC_ADMIN_ROLES, ...EXTERNAL_ADMIN_ROLES];
export const MAKER_ROLES = [...CKYC_MAKER_ROLES, ...EXTERNAL_MAKER_ROLES];
export const CHECKER_ROLES = [...CKYC_CHECKER_ROLES, ...EXTERNAL_CHECKER_ROLES];

export const getAccessRolesForUserType = (type: 'Admin' | 'Maker' | 'Checker'): string[] => {
    if (type === 'Admin') {
        return CKYC_ADMIN_ROLES;
    } else if (type === 'Checker') {
        return CKYC_CHECKER_ROLES;
    } else {
        return CKYC_MAKER_ROLES;
    }
};

export const camelCaseToNormal = (name: string): string => {
    const result = name.replace(/([A-Z])/g, ' $1');
    return result.charAt(0).toUpperCase() + result.slice(1).toLowerCase();
};

export enum SearchIdType {
    LOS_APP_ID = 'LOS_APP_ID',
    CKYC_ID = 'CKYC_ID',
    CKYC_REFERENCE_NUMBER = 'CKYC_REFERENCE_NUMBER',
    CKYC_NUMBER = 'CKYC_NUMBER',
    CUSTOMER_ID = 'CUSTOMER_ID',
    PAN = 'PAN',
}

export interface CaseHistoryData {
    searchParameter: string;
    customerName: string | null;
    triggerDate: string;
    searchDate: string;
    downloadDate: string;
    firstBatchUploadDate: string | null;
    res1Date: string | null;
    status: string;
    ckycStatus: string;
    failureReason: string;
    manualReviewFlag: boolean;
    ckycIdGenerationDate: string | null;
    ckycReferenceNumber: string | null;
    ckycNumber: string | null;
    notifiedToCkycDate: string | null;
    ckycOperationId: string | null;
    losAppId: string | null;
    ucic: string | null;
}
